import { buildBenchmarkFiltersPayload } from '../../../utils/buildBenchmarkFiltersPayload';

// Request body for one page of getProjectComparison. Both tables fetch their
// own list through this, so the two only differ by `listType` and paging.
// `isInitialFetch` marks the load that builds a section from nothing (first
// mount, new filters) as opposed to a search reload or a scrolled-to page. The
// reducer keeps its own loading flag for it — see fetchProjectComparison.
export const buildProjectComparisonPayload = ({ benchmarkFiltersAnalysis, listType, from, size, searchText, isInitialFetch }) => {
    const benchmarkFilters = buildBenchmarkFiltersPayload(benchmarkFiltersAnalysis);
    // Comparison spans a leader's whole history, so the date filter doesn't apply.
    delete benchmarkFilters.date;
    return { benchmarkFilters, listType, from, size, searchText, isInitialFetch: !!isInitialFetch };
};
